import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { AppStore } from '@/store';
import { ApiParams } from '@/core/http/ApiResource';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { User, useUser } from '@/modules/user/User';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserIndex',
  setup(__props) {

const resource = useUser();
const { $gettext } = useGettext();
const store = useStore<AppStore>();
const authUser = computed(() => store.state.authenticatedUser);
const defaultParams: ApiParams = {};
const userToDelete = ref<User>();

if (authUser.value?.type === 'MASTER') {
	defaultParams['master'] = '1';
}

const columns = [
	new Column<User>($gettext('Namn'), 'name', 'u.name', '+'),
	new Column<User>($gettext('E-post'), 'email', 'u.email'),
	new ActionColumn<User>()
		.withEditLink((u) => ({ name: 'user.edit', params: { id: u.id } }))
		.withDeleteLink((u: User) => {
			userToDelete.value = u;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Användare')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'user.create'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ny användare ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "default-params": defaultParams,
          "delete-title": _unref($gettext)('Ta bort användare'),
          "delete-name-key": "name",
          "to-delete": userToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((userToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})